import { render, staticRenderFns } from "./ModalEditProvincia.vue?vue&type=template&id=320b1edf&scoped=true"
import script from "./ModalEditProvincia.vue?vue&type=script&lang=js"
export * from "./ModalEditProvincia.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalEditProvincia.vue?vue&type=style&index=1&id=320b1edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b1edf",
  null
  
)

export default component.exports